// Some help functions that are used all over multiple components
// ****************************************************************

// turnDate
// Switch from dd-MM-YYYY to YYYY-MM-dd and vica versa
//
export const turnDate=(date) => {
    const hlpArr = date.split('-');
    return (hlpArr.reverse()).join('-');
};

// ****************************************************************
// nlStatus
// Translates the status into Dutch
//
export const nlStatus=(status) => {
    const translation = {
        initial: "Ingeschreven",
        registered: "Aangemeld",
        ready: "Staat klaar",
        busy: "Aan het zwemmen",
        done: "Klaar met zwemmen"
    }
    if (Object.keys(translation).includes(status)) {
        return translation[status];
    } else {
        return status;
    }
};

// ****************************************************************
// nlStatusFull
// Dutch sentence explaining the status
//
export const nlStatusFull=(status) => {
    const translation = {
        initial: "moet zich nog aanmelden.",
        registered: "is aangemeld.",
        ready: "staat klaar om te gaan zwemmen.",
        busy: "is aan het zwemmen.",
        done: "is klaar met zwemmen."
    }
    if (Object.keys(translation).includes(status)) {
        return `Deze deelnemer ${translation[status]}`;
    } else {
        return 'De status van deze deelnemer is onbekend';
    }
};

// ****************************************************************
// displayCapnr
// Displays capnr with or without color addition, depending on event.colors
//
export const displayCapnr=(capNr, eventColors) => {
    let result = capNr;
    if (eventColors && eventColors.length === 1) {
        const hlpArray = capNr.split(":");
        result = hlpArray[1];
    }
    return result;
};